import "lazyloadxt/dist/jquery.lazyloadxt.min.js";

$(".lazy").lazyLoadXT({
    //throttle: 0,
    //edgeY: 400,
    blankImage: null
});

